class ProductGallery extends HTMLElement {
    constructor() {
        super();
        this.mainSlider;
        this.thumbSlider;
        this.mainSliderWrapper = this.querySelector('[data-role="main-slider"]');
        this.thumbSlideWrapper = this.querySelector('[data-role="thumb-slider"]');
        this.thumbDots = this.querySelectorAll('[data-role="thumbs-dots"] button');
        this.arrowBtns = this.querySelectorAll('[data-role="nav-arrow"]');
        let mainSliderImages = Array.from(this.mainSliderWrapper.querySelectorAll("img"));


        window.Slider ? this.initalizeSlider.call(this, window.Slider) : "";
        document.addEventListener("custom:keenLoaded", (e) => {
            this.initalizeSlider.call(this, window.Slider)
        })
        document.addEventListener("custom:galleryUpdate", (e) => {
            this.mainSlider.moveToIdx(e.detail.index);
        })
        this.mainSlider.on("slideChanged", (slide) => {
            let currentActiveIndex = slide.track.details.rel;
            this.syncSlider(currentActiveIndex);
        })
        this.thumbSlider.on("slideChanged", (slide) => {
            let activeInd = slide.track.details.rel;
            slide.slides.forEach((el, index) => {
                if (activeInd == index) {
                    el.classList.add("active-thumb")
                } else {
                    el.classList.remove("active-thumb")
                }
            })
        })
        this.appendCustomCursor.call(this);
        this.thumbSlideWrapper.querySelectorAll(".keen-slider__slide").forEach((el, ind) => {
            el.addEventListener('click', () => {
                this.thumbSlider.moveToIdx(ind);
                this.mainSlider.moveToIdx(ind);
                this.thumbDots.forEach((el, index) => ind == index ? el.classList.add("active") : el.classList.remove("active"));
            })
        })

        this.thumbDots.forEach((el, index) => {
            el.addEventListener('click', () => {
                this.thumbDots.forEach((el, ind) => ind != index ? el.classList.remove("active") : el.classList.add("active"));
                this.thumbSlider.moveToIdx(index);
                this.mainSlider.moveToIdx(index);
            })
        })

        this.arrowBtns.forEach((el) => {
            el.addEventListener('click', () => {
                if (el.dataset.behave == 'next') {
                    this.mainSlider.next();
                } else {
                    this.mainSlider.prev();
                }

            })
        })
        mainSliderImages.forEach((el, ind) => el.addEventListener('click', () => {
            if (document.querySelector(`gallery-popup`)) {
                document.dispatchEvent(new CustomEvent("custom:galleryPopupDisplay", { detail: { media: el.closest('[data-media]').dataset.media } }))
            } else {
                this.mountPopupGallery.call(this, el.closest('[data-media]').dataset.media);
            }
        }));
    }
    WheelControls(slider) {
        var touchTimeout;
        var position;
        var wheelActive;

        function dispatch(e, name) {
            position.x -= e.deltaX;
            position.y -= e.deltaY;
            slider.container.dispatchEvent(
                new CustomEvent(name, {
                    detail: {
                        x: position.x,
                        y: position.y,
                    },
                })
            );
        }

        function wheelStart(e) {
            position = {
                x: e.pageX,
                y: e.pageY,
            };
            dispatch(e, 'ksDragStart');
        }

        function wheel(e) {
            if (e.deltaY == -0) {
                dispatch(e, 'ksDrag');
            }
        }

        function wheelEnd(e) {
            dispatch(e, 'ksDragEnd');
        }

        function eventWheel(e) {
            if (!wheelActive) {
                wheelStart(e);
                wheelActive = true;
            }
            wheel(e);
            clearTimeout(touchTimeout);
            touchTimeout = setTimeout(() => {
                wheelActive = false;
                wheelEnd(e);
            }, 50);
        }

        slider.on('created', () => {
            slider.container.addEventListener(
                'wheel',
                (e) => {
                    if (e.deltaY != -0) {
                        slider.container.removeEventListener('wheel', () => { });
                    } else {
                        eventWheel(e);
                    }
                },
                { passive: false }
            );
        },);
    }

    initalizeSlider(Slider) {
        console.log("loading slider")
        this.mainSlider = new Slider(this.mainSliderWrapper, {
            loop: true,
            slides: {
                perView: 1,
            }
        }, [this.WheelControls]);
        this.thumbSlider = new Slider(this.thumbSlideWrapper, {
            loop: true,
            slides: {
                perView: 4.8,
                spacing: 8
            }, breakpoints: {
                '(min-width: 500px)': {
                    slides: {
                        perView: 5,
                        spacing: 8
                    }
                },
            },
        }, [this.WheelControls]);
    }
    syncSlider(activeInd) {
        this.thumbSlider.moveToIdx(activeInd);
        this.thumbDots.forEach((el, ind) => ind != activeInd ? el.classList.remove("active") : el.classList.add("active"));
    }
    async memoizePopupGallery() {
        let data;
        let galleryData = window.sessionStorage[`${this.dataset.product}-popup`] ? window.sessionStorage[`${this.dataset.product}-popup`] : undefined;
        if (galleryData) {
            data = galleryData;
        } else {
            let url = window.location.pathname + "?view=popup";
            let htmlData = await fetch(url).then(res => res.text()).then(htmlText => htmlText);
            window.sessionStorage[`${this.dataset.product}-popup`] = htmlData;
            data = htmlData;
        }
        return data;
    }
    async mountPopupGallery(media) {
        document.querySelector('[data-role="zoom-loader"]').classList.remove('hidden');
        let htmlData = await this.memoizePopupGallery();
        document.querySelector('[data-role="zoom-loader"]').classList.add('hidden');
        let parser = new DOMParser();
        let html = parser.parseFromString(htmlData, "text/html");
        let galleryHtml = html.querySelector('gallery-popup');
        let zoomHtml = html.querySelector('zoom-box');
        document.body.appendChild(galleryHtml);
        document.body.appendChild(zoomHtml);
        document.dispatchEvent(new CustomEvent("custom:galleryPopupDisplay", { detail: { media: media } }))
    }
    appendCustomCursor() {
        let cursorDiv = document.createElement('div');
        cursorDiv.setAttribute('id', "custom-cursor");
        cursorDiv.style.background = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='44' height='44' viewBox='0 0 44 44' fill='none'%3E%3Cpath d='M44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22Z' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M22 14C22.5523 14 23 14.4477 23 15V21H29C29.5523 21 30 21.4477 30 22C30 22.5523 29.5523 23 29 23H23V29C23 29.5523 22.5523 30 22 30C21.4477 30 21 29.5523 21 29V23H15C14.4477 23 14 22.5523 14 22C14 21.4477 14.4477 21 15 21H21V15C21 14.4477 21.4477 14 22 14Z' fill='%23101010'/%3E%3C/svg%3E")`;
        cursorDiv.style.position = 'fixed';
        cursorDiv.style.width = '44px';
        cursorDiv.style.height = '44px';
        cursorDiv.style.zIndex = '1000';
        cursorDiv.style.transform = 'translate(-50%,-50%)';
        cursorDiv.style.backgroundPosition = "center";
        cursorDiv.style.pointerEvents = 'none';

        document.addEventListener('mousemove', (e) => {
            if (window.innerWidth > 1024) {
                let closest = e.target.closest('[data-role="popup-main-slider"]') || e.target.closest('[data-role="main-slider"]');
                if (e.target.nodeName == "IMG" && closest) {
                    document.body.appendChild(cursorDiv);
                    let x = e.clientX;
                    let y = e.clientY;
                    cursorDiv.style.left = `${x}px`;
                    cursorDiv.style.top = `${y}px`;
                } else {
                    document.getElementById('custom-cursor') ? cursorDiv.remove() : "";
                }
            }
        });
        document.addEventListener('mouseleave', (e) => {
            document.getElementById('custom-cursor') ? document.getElementById('custom-cursor').remove() : "";
        });
    }
}


customElements.define("product-gallery", ProductGallery);

class DeffereMedia extends HTMLElement {
    constructor() {
        super()
        this.templateContent = this.querySelector("template").innerHTML;
        this.image = this.querySelector("img");
        this.observer.observe(this.image)
    }
    observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const intersecting = entry.isIntersecting
            if (intersecting) {
                this.observer.unobserve(this.image);
                this.innerHTML = this.templateContent;
            }
        })
    })
}
customElements.define("deffered-media", DeffereMedia);


